import { keycloak } from "../..";
import { rootApi } from "../../app/apis/api.root";
import { API_TAGS } from "../../app/constants";
import { API_URL } from "../../constants/urls.constants";
import { toast } from "../../lib/toast";
import { CommonResponse, TGetMeResponse, USER_ROLES } from "../../types";
import { setAuthInfo } from "./auth.slice";

export const authApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getMe: builder.query<CommonResponse<TGetMeResponse>, void>({
      query: () => ({
        url: API_URL.getMe,
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;

          const role = data?.data?.user?.role;

          if (role !== USER_ROLES.ADMIN && role !== USER_ROLES.USER) {
            toast("error", "You are not allowed to log in to this system");
            setTimeout(async () => {
              await keycloak.logout();
              localStorage.clear();
            }, 500);

            return;
          }

          dispatch(setAuthInfo(data?.data?.user));
        } catch (err) {
          setTimeout(async () => {
            await keycloak.logout();
            localStorage.clear();
          }, 500);
        }
      },
      providesTags: () => [{ type: API_TAGS.GET_ME }],
    }),
    uploadFile: builder.mutation({
      query: (data) => {
        return {
          url: API_URL.uploadFile,
          method: "PATCH",
          body: data,
        };
      },
    }),
    uploadMobileToken: builder.mutation({
      query: (data) => {
        return {
          url: API_URL.uploadMobileToken,
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

export const {
  useGetMeQuery,
  useUploadMobileTokenMutation,
  useUploadFileMutation,
} = authApi;
